module.exports = __webpack_public_path__ + "@/assets/img/background-login.dc12b53f.png";